function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontsize/fontsizeediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FontSizeCommand from './fontsizecommand';
import { normalizeOptions } from './utils';
import { buildDefinition, FONT_SIZE } from '../utils';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * The font size editing feature.
 *
 * It introduces the {@link module:font/fontsize/fontsizecommand~FontSizeCommand command} and the `fontSize`
 * attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
 * as a `<span>` element with either:
 * * a style attribute (`<span style="font-size:12px">...</span>`),
 * * or a class attribute (`<span class="text-small">...</span>`)
 *
 * depending on the {@link module:font/fontsize~FontSizeConfig configuration}.
 *
 * @extends module:core/plugin~Plugin
 */

var FontSizeEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(FontSizeEditing, _Plugin);

  var _super = _createSuper(FontSizeEditing);

  /**
   * @inheritDoc
   */
  function FontSizeEditing(editor) {
    var _this;

    _classCallCheck(this, FontSizeEditing);

    _this = _super.call(this, editor); // Define default configuration using named presets.

    editor.config.define(FONT_SIZE, {
      options: ['tiny', 'small', 'default', 'big', 'huge'],
      supportAllValues: false
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontSizeEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor; // Allow fontSize attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: FONT_SIZE
      });
      editor.model.schema.setAttributeProperties(FONT_SIZE, {
        isFormatting: true,
        copyOnEnter: true
      });
      var supportAllValues = editor.config.get('fontSize.supportAllValues'); // Define view to model conversion.

      var options = normalizeOptions(this.editor.config.get('fontSize.options')).filter(function (item) {
        return item.model;
      });
      var definition = buildDefinition(FONT_SIZE, options); // Set-up the two-way conversion.

      if (supportAllValues) {
        this._prepareAnyValueConverters(definition);
      } else {
        editor.conversion.attributeToElement(definition);
      } // Add FontSize command.


      editor.commands.add(FONT_SIZE, new FontSizeCommand(editor));
    }
    /**
     * These converters enable keeping any value found as `style="font-size: *"` as a value of an attribute on a text even
     * if it is not defined in the plugin configuration.
     *
     * @param {Object} definition {@link module:engine/conversion/conversion~ConverterDefinition Converter definition} out of input data.
     * @private
     */

  }, {
    key: "_prepareAnyValueConverters",
    value: function _prepareAnyValueConverters(definition) {
      var editor = this.editor; // If `fontSize.supportAllValues=true`, we do not allow to use named presets in the plugin's configuration.

      var presets = definition.model.values.filter(function (value) {
        return !String(value).match(/[\d.]+[\w%]+/);
      });

      if (presets.length) {
        /**
         * If {@link module:font/fontsize~FontSizeConfig#supportAllValues `config.fontSize.supportAllValues`} is `true`,
         * you need to use numerical values as font size options.
         *
         * See valid examples described in the {@link module:font/fontsize~FontSizeConfig#options plugin configuration}.
         *
         * @error font-size-invalid-use-of-named-presets
         * @param {Array.<String>} presets Invalid values.
         */
        throw new CKEditorError('font-size-invalid-use-of-named-presets', null, {
          presets: presets
        });
      }

      editor.conversion.for('downcast').attributeToElement({
        model: FONT_SIZE,
        view: function view(attributeValue, _ref) {
          var writer = _ref.writer;

          if (!attributeValue) {
            return;
          }

          return writer.createAttributeElement('span', {
            style: 'font-size:' + attributeValue
          }, {
            priority: 7
          });
        }
      });
      editor.conversion.for('upcast').attributeToAttribute({
        model: {
          key: FONT_SIZE,
          value: function value(viewElement) {
            return viewElement.getStyle('font-size');
          }
        },
        view: {
          name: 'span',
          styles: {
            'font-size': /.*/
          }
        }
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'FontSizeEditing';
    }
  }]);

  return FontSizeEditing;
}(Plugin);

export { FontSizeEditing as default };